import SpecialistProtected from "../layout/Protected/SpecialistProtected"
import Layout from "../layout/specialist"
import { Route } from "react-router-dom"

// Dashboard layout
import Dashboard from "../pages/Specialist/Dashboard"

// Dashboard components
import SpecialistBookedWebinars from "../pages/Specialist/Dashboard/webinars/booked/SpecialsitBooked"
import EditAvailability from "../pages/Specialist/Dashboard/availability/update"
import Availability from "../pages/Specialist/Dashboard/availability"
import WebinarsDetails from "../pages/Specialist/Dashboard/webinars/Details"
import BookedWebinars from "../pages/Specialist/Dashboard/webinars/booked"
import CreateWebinar from "../pages/Specialist/Dashboard/webinars/create"
import SingleWebinar from "../pages/Specialist/Dashboard/webinars/single"
import ForumComments from "../components/dashboard/Forum/ForumComment"
import Bookings from "../pages/Specialist/Dashboard/webinars/bookings"
import AllWebinars from "../pages/Specialist/Dashboard/webinars/list"
import BlogComments from "../components/dashboard/Blogs/BlogComments"
import EditComment from "../components/dashboard/Drafts/EditComment"
import EditProfile from "../pages/Specialist/Dashboard/EditProfile"
import ForumLikes from "../components/dashboard/Forum/ForumLikes"
import EditForum from "../components/dashboard/Forum/EditForum"
import AddForum from "../components/dashboard/Forum/AddForum"
import AllForum from "../components/dashboard/Forum/AllForum"
import AllBlogs from "../components/dashboard/Blogs/AllBlogs"
import AddBlog from "../components/dashboard/Blogs/AddBlog"
import Details from "../pages/Specialist/Dashboard/Details"
import Messages from "../components/dashboard/Messages"
import Password from "../components/dashboard/Password"
import Draft from "../components/dashboard/Drafts"

// Appointments components
// import AcceptedAppointments from "../pages/Specialist/Dashboard/appointments/accepted"
import AcceptedAppointments from "../pages/Specialist/Dashboard/appointments/accepted"
import PendingAppointments from "../pages/Specialist/Dashboard/appointments/pending"
import PastAppointments from "../pages/Specialist/Dashboard/appointments/past"
import Appointments from "../pages/Specialist/Dashboard/appointments"

// Wallet + Connect
import WalletPage from "../pages/Specialist/Dashboard/wallet"
import ConnectSuccess from "../pages/Specialist/Dashboard/wallet/ConnectSuccess"
import ConnectRefresh from "../pages/Specialist/Dashboard/wallet/ConnectRefresh"

// Member components
import Single from "../pages/Specialist/Dashboard/my-member/member-details"
import Schedules from "../pages/Specialist/Dashboard/schedules"
import Members from "../pages/Specialist/Dashboard/my-member"

const SpecialistRoutes = (
  <Route path="/specialist" element={<Layout />}>
    <Route path="edit-profile" element={<EditProfile />} />

    <Route path="profile" element={<SpecialistProtected><Dashboard /></SpecialistProtected>}>
      <Route index element={<Details />} />
      <Route path="draft" element={<Draft />} />
      <Route path="messages" element={<Messages />} />
      <Route path="appointment-messages" element={<Messages isAppointmentChat={true} />} />
      <Route path="add-blog" element={<AddBlog />} />
      <Route path="all-blog" element={<AllBlogs />} />
      <Route path="add-forum" element={<AddForum />} />
      <Route path="all-forum" element={<AllForum />} />
      <Route path="bookings/:id" element={<Bookings />} />
      <Route path="forum-likes" element={<ForumLikes />} />
      <Route path="edit-forum/:id" element={<EditForum />} />
      <Route path="change-password" element={<Password />} />
      <Route path="add-webinar" element={<CreateWebinar />} />
      <Route path="webinar/:id" element={<SingleWebinar />} />
      <Route path="webinars/:type" element={<AllWebinars />} />
      <Route path="blog-comments" element={<BlogComments />} />
      <Route path="edit-comment/:id" element={<EditComment />} />
      <Route path="forum-comments" element={<ForumComments />} />
      <Route path="availability" element={<Availability />} />
      <Route path="schedules" element={<Schedules />} />
      <Route path="availability/update" element={<EditAvailability />} />
      <Route path="booked-webinar/:type" element={<BookedWebinars />} />
      <Route path="webinar-details/:webinarId" element={<WebinarsDetails />} />
      <Route path="specialist-booked-webinar/:type" element={<SpecialistBookedWebinars />} />

      <Route path="members" element={<Members />} />
      <Route path="member/:id" element={<Single />} />

      {/* Wallet & Earnings */}
      <Route path="wallet" element={<WalletPage />} />
      <Route path="connect/success" element={<ConnectSuccess />} />
      <Route path="connect/refresh" element={<ConnectRefresh />} />

      <Route path="appointments" element={<Appointments />}>
        <Route path="past" element={<PastAppointments />} />
        <Route path="pending" element={<PendingAppointments />} />
        {/* <Route path="accepted" element={<AcceptedAppointments />} /> */}
        <Route path="upcoming" element={<AcceptedAppointments />} />

      </Route>
    </Route>
  </Route>
)

export default SpecialistRoutes